export const condolivre = {
	logo: {
		standard: '/images/Logo_condolivre_pos.png',
		custom: '/images/Logo_condolivre_neg.png',
		width: 120,
		height: 31,
	},
	name: {
		standard: 'Condo Livre',
		custom: 'CondoLivre',
	},
	favico: '/favicon.ico',
	footer: {
		logo: {
			standard: '/images/Logo_condolivre_pos.png',
			custom: '/images/Logo_condolivre_neg.png',
			width: 200,
			height: 52,
		},
		text: 'A CondoLivre Análise de Crédito e Cobrança Ltda, inscrita sob o CNPJ 28.314.050/0001-62, é uma Fintech especializada em ',
		cnpj: 'soluções de crédito para o universo de condomínios..',
		support_phone: '(11) 98084-1487',
		whatsapp_phone: '5511980841487',
	},
	sidebar: {
		logo: {
			standard: '/images/Logo_condolivre_pos.png',
			custom: '/images/Logo_condolivre_neg.png',
			width: 200,
			height: 52,
		},
	},
	theme: {
		basicColor: '#4865d9',
		customColor: '#F05A22',
	},
	pathname: 'cred',
};

export const wohpag = {
	logo: {
		standard: '/images/Logo_wohpag_pos.png',
		custom: '/images/Logo_wohpag_neg.png',
		width: 186,
		height: 33,
	},
	name: {
		standard: 'Wohpag',
		custom: 'Wohpag',
	},
	favico: '/favicon-wohpag.ico',
	footer: {
		logo: {
			standard: '/images/footer_wohpag.png',
			custom: '/images/footer_wohpagneg.png',
			width: 214,
			height: 17,
		},
		text: 'Woh Instituição de Pagamentos Ltda. | Condolivre Análise de Crédito e Cobrança Ltda.',
		cnpj: 'CNPJ: 38.253.318/0001-57 | CNPJ: 29.314.050/0001-62',
		support_phone: '(21) 96744-5464',
		whatsapp_phone: '5521967445464',
	},
	sidebar: {
		logo: {
			standard: '/images/sidebar_wohpag.png',
			custom: '/images/sidebar_wohpag.png',
			width: 66,
			height: 35,
		},
	},
	theme: {
		basicColor: '#80298F',
		customColor: '#F05A22',
	},
	pathname: 'wohpag',
};
